import { required, email, maxLength } from 'vuelidate/lib/validators'

export const validations = {
    first_name: {
        required,
        maxLength: maxLength(100),
    },
    last_name: {
        required,
        maxLength: maxLength(100),
    },
    email: {
        required,
        maxLength: maxLength(100),
        email,
    },
    phone: {
        required,
        maxLength: maxLength(100),
    },
    category: {
        required,
    },
    notes: {
        required,
        maxLength: maxLength(1000),
    },
}

export const messages = {
    first_name: {
        required: 'Required',
        maxLength: 'This field can\'t be more than 100 characters long',
    },
    last_name: {
        required: 'Required',
        maxLength: 'This field can\'t be more than 100 characters long',
    },
    email: {
        required: 'Required',
        maxLength: 'This field can\'t be more than 100 characters long',
        email: 'Must be a valid email address',
    },
    phone: {
        required: 'Required',
        maxLength: 'This field can\'t be more than 100 characters long',
    },
    category: {
        required: 'Required',
    },
    notes: {
        required: 'Required',
        maxLength: 'Can\'t be more than 100 characters long',
    },
}
